<template>
  <div class="box1">

    <div class="tabop flex">
      <div class="tabopson">
        规格名称
      </div>
      <div class="tabopson">
        对应值
      </div>
    </div>
    <div class="teble flex" v-for="(value, key, index) in detailscanshu">
      <div class="tebleson">
        {{key}}
      </div>
      <div class="tebleson _colorred">
        {{value}}
      </div>
    </div>
  </div>
</template>
<script>
    export default {
      props: {
        detailscanshu: {
          // type: String,
          default () {
            return {};
          }
        }
      },
        data() {
            return {

            }
        },
    }
</script>
<style scoped>
    .box1 {
        border: 1px solid #dddddd;
    }

    .tabop {
        width: 100%;
        height: 40px;
        line-height: 40px;
        font-size: 16px;
        background-color: #f6f6f6;
    }

    .tabopson {
        flex: 1;
        height: 40px;
        line-height: 40px;
        font-size: 16px;
        text-align: center;
    }

    .teble {
        width: 100%;
        border-top: 1px solid #dddddd;
        cursor: pointer;
    }

    .teble:nth-child(even) {
        background: #ffffff;
        /*奇数行*/
    }

    .teble:nth-child(odd) {
        /*偶数行*/
        background: #f6f6f6;
    }

    .teble:hover {
        transition: all 0.1s linear;
        background: #f5f7fa;
    }

    .tebleson {
        flex: 1;
        height: 40px;
        line-height: 40px;
        font-size: 14x;
        text-align: center;
    }

    ._colorred {
        color: #d81023;
    }
</style>
